import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import ExpensableDetail from 'modules/expenses/components/expenses/Detail'

import { useMyExpenses } from './MyExpensesContext'

const MyExpenseDetailPage = () => {
  const navigate = useNavigate()
  const { expense_id } = useParams()
  const { navigation } = useNavigation()
  const [searchParams] = useSearchParams()
  const { featureAvailabilities, data } = useMyExpenses()

  if (!expense_id) {
    throw new Error('Required expense_id param')
  }

  return (
    <ExpensableDetail
      expensableId={expense_id}
      onClose={() =>
        navigate({
          pathname: navigation.myExpenses.list.expenses.fullPath(),
          search: searchParams.toString(),
        })
      }
      taxAgencyHomologationEnabled={featureAvailabilities.taxAgencyHomologation}
      reimburseThroughPayrollEnabled={featureAvailabilities.reimburseThroughPayroll}
      reportOnBehalfEnabled={featureAvailabilities.reportOnBehalf}
      canUseSpendingPolicies={featureAvailabilities.canUseSpendingPolicies}
      canCreateExpensesForOthers={data.expenses._policies.expenseCreateExpensesForOthers.can}
      canSeeEmployeeLegalEntity={data.expenses._policies.expenseSeeEmployeeLegalEntity.can}
      canCustomizeSettings={data.expenses._policies.expenseCustomizeSettings.can}
      accountingTabEnabled={false}
      canReviewExpensable={false}
      projectsManagementEnabled={featureAvailabilities.projectsManagement}
      showRecommendationSystem
      hasMileageMultipleStops={featureAvailabilities.mileageMultipleStopsEnabled}
    />
  )
}

export default MyExpenseDetailPage
